import React from "react";

import { dummyVideoRetrievalService } from "@/api/services/implementations";
import { VideoRetrievalService } from "@/api/services/interfaces";


export const VideoRetrievalContext = React.createContext<VideoRetrievalService>(dummyVideoRetrievalService);
export const VideoRetrievalProvider = VideoRetrievalContext.Provider;
export const VideoRetrievalConsumer = VideoRetrievalContext.Consumer;

interface Props {
    service: VideoRetrievalService;
}

export const VideoRetrievalContextWrapper: React.FC<Props> = ({ service, children }) => {
    return <VideoRetrievalProvider value={service}>{children}</VideoRetrievalProvider>;
};
